import React from "react"

import { useStyles } from "@/components/CampaignActionCardTracker/ActionItem/styles"
import { Icon } from "@/components/Icon"

interface ActionItemProps {
    position: string
    icon?: string
    iconFamily?: string
    title?: string
}

const UNSELECTED_ICON_NAME = "layer-plus"
const UNSELECTED_TITLE = "Select action"
const DEFAULT_ICON_FAMILY = "far"

export const ActionItem = ({
    icon = UNSELECTED_ICON_NAME,
    iconFamily = DEFAULT_ICON_FAMILY,
    title = UNSELECTED_TITLE,
    position,
}: ActionItemProps) => {
    const isSelected = title !== UNSELECTED_TITLE && icon !== UNSELECTED_ICON_NAME
    const { classes } = useStyles({ isSelected })

    return (
        <div className={classes.orderChild}>
            <div className={classes.icon}>
                <Icon icon={icon} iconFamily={iconFamily} />
            </div>
            <div className={classes.infoContainer}>
                <p className={classes.position}>{position} action</p>
                <p className={classes.campaignType}>{title}</p>
            </div>
        </div>
    )
}
